import * as React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {toastr} from 'react-redux-toastr'
import {Button, TYPES} from './../shared/button'
import './../../styles/note/newNote.css'
import Spinner from './../shared/spinner'

class NewNote extends React.Component {
  constructor() {
    super()

    this.state = {
      title: '',
      description: '',
      reviewer: '',
      sendZoom: false,
      noteIsBeingSubmitted: false
    }
  }

  componentDidMount() {
    document.documentElement.style.setProperty('--spinner-color', '#FFFFFF');
    this.imageCheck()
    this.updateCanvas()
  }

  toast = () => {
    toastr.removeByType('error')
    toastr.success('Success', 'Note saved')
    this.props.history.push(`/visits`)
  }

  imageCheck() {
    const id = this.props.recording.id
    if(this.props.screenshot === null) {
      window.location.replace(`/recordings/${id}`)
    }
  }

  updateCanvas = () => {
    const canvasForNewNote = this.refs.canvas
    const ctx = canvasForNewNote.getContext('2d')
    var imageFromProps = null
    if(!this.props.zoomScreenshot) {
      imageFromProps = this.props.screenshot
    } else {
      this.setState({sendZoom: true})
      imageFromProps = this.props.zoomScreenshot
    }
    var image = new Image()
    image.onload = () => {
      const halfWindowWidth = window.innerWidth * .5
      const aspectRatio = image.width / image.height
      const adjustedHeight = halfWindowWidth / aspectRatio
      canvasForNewNote.width = halfWindowWidth
      canvasForNewNote.height = adjustedHeight
      if(image.width === image.height) {
        canvasForNewNote.width = image.width * 1.2
        canvasForNewNote.height = image.height * 1.2
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvasForNewNote.height, canvasForNewNote.height)
      } else {
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvasForNewNote.width, canvasForNewNote.height)
      }
      ctx.beginPath()
      ctx.arc(100, 100, 75, 0, Math.PI * 2, false)
      ctx.lineWidth = 2
      ctx.strokeStyle = 'blue'
      ctx.stroke()
    }
    image.src = imageFromProps
    canvasForNewNote.addEventListener('click', function(evt) {
      var mousePos = getMousePos(canvasForNewNote, evt)
      var image = new Image()
      image.onload = () => {
        if(image.width === image.height) {
          canvasForNewNote.width = image.width * 1.2
          canvasForNewNote.height = image.height * 1.2
          ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvasForNewNote.width, canvasForNewNote.height)
        } else {
          ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvasForNewNote.width, canvasForNewNote.height)
        }
        ctx.beginPath()
        ctx.arc(mousePos.x, mousePos.y, 75, 0, Math.PI * 2, false)
        ctx.lineWidth = 2
        ctx.strokeStyle = 'blue'
        ctx.stroke()
      }
      image.src = imageFromProps
    }, false)
    function getMousePos(canvasForNewNote,evt) {
      var rect = canvasForNewNote.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      }
    }

    return canvasForNewNote
  }

  addNote = (event) => {
    const { token } = this.props.auth
    this.setState({noteIsBeingSubmitted: true})

    event.preventDefault()
    let payload = {
      reviewer: this.state.reviewer,
      title: this.state.title,
      description: this.state.description,
      location:this.props.recording.location,
      recording: this.props.recording.id,
      visit: this.props.recording.visit.id,
      image: this.refs.canvas.toDataURL('image/jpeg', 1.0),
    }
    if(this.state.sendZoom) {
      payload['zoom_image'] = this.props.screenshot
    }
    axios.post(
      '/api/notes.json',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${token}`
        }
      }
    ).then(response => {
        this.toast()
      }
    ).catch(error => {
        toastr.error('Error', "Couldn't save note")
        }
      )
  }

  render () {
    const {noteIsBeingSubmitted} = this.state
    return (
      <div className='new-note-container'>
        <div className='new-note-image' id='note-image'>
          <canvas ref='canvas'/>
        </div>
        <div>
          <form onSubmit={this.addNote} className='new-note-input'>
            <input
              onChange={(e) => {this.setState({title: e.target.value})}}
              placeholder='Note Title'
              id='customer'/>
            <textarea
              onChange={(e) => {this.setState({description: e.target.value})}}
              placeholder='Description'
              id='notes'/>
            <input
              onChange={(e) => {this.setState({reviewer: e.target.value})}}
              placeholder='Reviewer'
              id='reviewer'/>
            <div className='save-button'>
            {!noteIsBeingSubmitted &&
              <Button
                text='Save Note'
                type='saveNote'
                buttonType={TYPES.SUBMIT}
              />
            }
            {noteIsBeingSubmitted &&
              <div id='loading-button'>
                <Spinner id='save-note' size='25px'/>
              </div>
            }
            </div>
          </form>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect( mapStateToProps )( NewNote )



// WEBPACK FOOTER //
// ./src/components/note/newNote.js